/**Import react section */
import React from 'react'
import propTypes from 'prop-types'

/** Material UI import section */
import {
    Button,
} from '@material-ui/core';

const ButtonCancel = (props) => {
    const { isSaving, onCancelClick, title, className} = props;

    const onButtonCancelClick = () => {
        if (onCancelClick) {
            onCancelClick()
        }
    }

    return (
        <Button
            color='inherit'
            variant='text'
            disabled={isSaving}
            className={className}
            onClick={onButtonCancelClick}
        >
            {title}
        </Button>
    )
}

ButtonCancel.propTypes = {
    /**Confirm the operation to be performed*/
    onCancelClick: propTypes.func.isRequired,
    /**Determinate if saving an operation */
    isSaving: propTypes.bool,
    /**Determinate el title of button */
    title: propTypes.node.isRequired,
}

ButtonCancel.defaultProps = {
    isSaving: false,
    title: '',
    onCancelClick: () =>
        console.warn('Callback [onCancelClick] no defined'),

}

export default ButtonCancel
